const routes = [
    {
        path: '/hierarchy-management',
        name: 'hierarchy-management',
        component: () => import('@/modules/managers/hierarchyManagement/HierarchyManagement.vue')
    }
]

export default routes
